import { render } from "./FromSubmission.vue?vue&type=template&id=b31933da&scoped=true"
import script from "./FromSubmission.vue?vue&type=script&lang=js"
export * from "./FromSubmission.vue?vue&type=script&lang=js"

import "./FromSubmission.vue?vue&type=style&index=0&id=b31933da&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b31933da"]])

export default __exports__